import axios from 'axios';

import addTokensInLocalStorage from 'utils/updateTokensInLocalStorage';
import { UpdateAccessToken } from './token';
import logout from '../utils/logout';

const baseURL = process.env.REACT_APP_BASE_API_URL;

export const http = axios.create({
  baseURL,
});

const onRequest = (config) => {
  const token = localStorage.getItem('accessToken');

  if (token !== null && config?.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

const onRequestError = (error) => Promise.reject(error);

const onResponse = (config) => config;

const onResponseError = async (error) => {
  const originalRequest = error.config;

  // eslint-disable-next-line no-underscore-dangle
  if (error?.response?.status === 401 && error.config && !error.config._isRetry) {
    // eslint-disable-next-line no-underscore-dangle
    originalRequest._isRetry = true;

    try {
      const { data } = await UpdateAccessToken();
      addTokensInLocalStorage(data);
      return http.request(originalRequest);
    } catch (error) {
      logout();
      throw error;
    }
  }

  throw error;
};

http.interceptors.request.use(onRequest, onRequestError);

http.interceptors.response.use(onResponse, onResponseError);
